__turbopack_context__.v({
  "faqAccordionContainer": "faq-module__lho0eG__faqAccordionContainer",
  "faqAccordionContent": "faq-module__lho0eG__faqAccordionContent",
  "faqAccordionIcon": "faq-module__lho0eG__faqAccordionIcon",
  "faqAccordionTitle": "faq-module__lho0eG__faqAccordionTitle",
  "faqContainer": "faq-module__lho0eG__faqContainer",
  "faqContent": "faq-module__lho0eG__faqContent",
  "faqSubtitle": "faq-module__lho0eG__faqSubtitle",
  "faqTextContainer": "faq-module__lho0eG__faqTextContainer",
  "faqTitle": "faq-module__lho0eG__faqTitle",
  "open": "faq-module__lho0eG__open",
});
